import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { SectionTitle } from '@cc-shopping/ui/composites/SectionTitle';
import { Box } from '@mui/material';
import { LinkItem } from 'src/app/credit-cards/reviews/components/Body/RelatedLinks/components/LinkItem';
import { useReviewContext } from '../../Context';
export const RelatedLinks = () => {
  const {
    relatedLinks
  } = useReviewContext();
  if (relatedLinks.length === 0) {
    return null;
  }
  let linkCounter = -1;
  return <FeatureViewed entityName="Navigate to roundups" entitySection="Navigate to roundups" impressionPosition={7}>
      <Box>
        <SectionTitle heading={{
        text: 'Looking For Something Else?'
      }} icon={{
        iconNode: <span aria-hidden="true" data-testid="section-title-icon" className="mask-icon mask-icon-payment" style={{
          width: '2rem',
          height: '2rem',
          backgroundColor: '#008254'
        }} />
      }} />
        {relatedLinks.map(relatedLink => <Box key={relatedLink.heading} sx={theme => ({
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
          paddingLeft: 4
        },
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 4
      })}>
            {relatedLink.links.map(link => {
          linkCounter++;
          return <LinkItem key={link.text} text={link.text} url={link.url} index={linkCounter} />;
        })}
          </Box>)}
      </Box>
    </FeatureViewed>;
};